export default {
  headline: 'Keep Your Team On Track',
  strapline: 'Harvey brings Harvest time tracking into Slack to get your team quickly and easily tracking their hours and keep your projects running smoothly. Contribute to the project on GitHub!',
  ctaLabel: 'Fork on GitHub'
};